<template>
	<v-row v-if="!isSectionHidden" class="pa-0 ma-0" justify="center">
		<v-col
			v-for="(field, index) in visibleFields"
			:key="index"
			:lg="getColSize(field, 'lg')"
			:md="getColSize(field, 'md')"
			:sm="getColSize(field, 'sm')"
			class="py-0"
		>
			<v-card class="background-2" elevation="0">
				<v-card-text class="text-center pa-0">
					<v-icon :color="field.color" :size="getIconSize(field)" class="mb-1">{{ field.icon }}</v-icon>
					<div :class="getLabelClass(field)">{{ field.text }}</div>
					<div
						:style="getValueStyle(field)"
						class="font-weight-bold"
						:class="getValueClass(field)"
					>
						{{ formatValue(field) }}
					</div>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'TotalsCards',

	props: {
		totalsFields: {
			type: Array,
			default: () => []
			// { text, value, key, icon, type, color, labelClass, large }
		},
		data: {
			type: Object,
			default: () => ({})
		},
		colSizes: {
			type: Object,
			default: () => ({
				lg: 2,
				md: 3,
				sm: 4
			})
		},
		largeColSizes: {
			type: Object,
			default: () => ({
				lg: 3,
				md: 4,
				sm: 6
			})
		},
		hidden: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		visibleFields() {
			// Fields are already filtered by the backend based on permissions
			return this.totalsFields || []
		},

		isSectionHidden() {
			// Section is hidden if explicitly marked as hidden or if there are no visible fields
			return this.hidden || this.visibleFields.length === 0
		}
	},

	methods: {
		getColSize(field, breakpoint) {
			if (field.large) {
				return this.largeColSizes[breakpoint]
			}
			return this.colSizes[breakpoint]
		},

		getIconSize(field) {
			return field.large ? 36 : 28
		},

		getLabelClass(field) {
			const baseClass = field.large ? 'text-subtitle-2' : 'text-caption'
			return field.labelClass ? `${baseClass} ${field.labelClass}` : baseClass
		},

		getValueStyle(field) {
			const fontSize = field.large ? '24px' : '16px'
			return `font-size: ${fontSize} !important`
		},

		getValueClass(field) {
			const colorClass = this.getTextColorClass(field.color)
			return field.large ? `text-h5 ${colorClass}` : `text-h6 ${colorClass}`
		},

		formatValue(field) {
			const value = this.data[field.key]
			if (value === null || value === undefined) {
				return '-'
			}

			switch (field.type) {
				case 'currency':
					return this.$options.filters.currency(value)
				case 'duration':
					return this.$options.filters.duration(value)
				case 'number':
					return value.toLocaleString('it-IT')
				case 'percentage':
					return this.$options.filters.percentage(value)
				default:
					return value
			}
		},

		getTextColorClass(color) {
			if (!color) return ''
			const parts = color.split(' ')
			if (parts.length > 1) {
				return `${parts[0]}--text text--${parts[1]}`
			}
			return `${color}--text`
		}
	}
}
</script>
